import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { TextOperationService } from '../../../services';
import {
  DEFAULT_REFINE_TEXT_STATE,
  buildRefineTextRequest,
  type RefineTextFormState,
} from './buildRequests';
import { useRunTextOperation } from './useTextOperationMutation';
import { TEXT_OPERATION_CATALOG } from './operationCatalog';
import { PanelScaffold } from './PanelScaffold';
import type { TextPanelProps } from './panelProps';

export const RefinePanel: React.FC<TextPanelProps> = ({
  ensureSession,
  isCreatingSession = false,
  documentId,
  sectionId,
  onResult,
}) => {
  const [state, setState] = useState<RefineTextFormState>(DEFAULT_REFINE_TEXT_STATE);
  const { run, mutation, validationError } = useRunTextOperation(
    TextOperationService.refine,
    ensureSession,
    documentId,
    { onResult },
  );

  const needsDocument = !documentId;
  const handleSubmit = () => run((sid, docId) => buildRefineTextRequest(state, sid, docId, sectionId));

  return (
    <PanelScaffold
      meta={TEXT_OPERATION_CATALOG.Refine}
      needsDocument={needsDocument}
      validationError={validationError}
      mutationError={mutation.isError ? mutation.error : null}
      busy={mutation.isPending}
      starting={isCreatingSession}
      submitDisabled={mutation.isPending || isCreatingSession || needsDocument}
      submitLabel="Refine"
      busyLabel="Refining…"
      onSubmit={handleSubmit}
    >
      <TextField
        label="Direction (optional)"
        value={state.direction}
        onChange={e => setState(s => ({ ...s, direction: e.target.value }))}
        size="small"
        fullWidth
        multiline
        minRows={1}
        maxRows={3}
        placeholder="e.g. tighten the prose, cut adverbs"
      />
    </PanelScaffold>
  );
};
